export const data = {
    category: "",
    tags: [""],
    question: "",
    response: "",
    top_query: false,
    countries: [""]
}